<div class="row">
  <div class="col-md-11">
    <div class="panel panel-default panel-box">
      <div class="panel-heading branch-title">
        <h3 class="panel-title">{{ 'pages.branchManagementPage.workingHours.title' | translate }}</h3>
      </div>
      <div class="panel-body">
        <nav class="navbar navbar-users">
          <ul class="nav navbar-nav">
            <li><a class="active">{{ 'pages.branchManagementPage.workingHours.defaultWorkingHours' | translate }}</a></li>
            <li><a>{{ 'pages.branchManagementPage.workingHours.exception' | translate }}</a></li>
          </ul>
        </nav>
        <div class="row" *ngFor="let day of workingDays; i as index">
          <div class="col-md-2 align-lft padd-top5p">
            <div class="form-group">
              <input type="checkbox" checked disabled />
              <span class="padd-lft2p"> {{getDayName(day)}}</span>
            </div>
          </div>
          <div class="col-md-1">
            <input type="text" class="form-control" placeholder="1:00 am" disabled [(ngModel)]="businessHours[0]"/>
          </div>
          <div class="col-md-1 center padd-top5p">
            <span>to</span>
          </div>
          <div class="col-md-1">
            <input type="text" class="form-control" placeholder="7:00 am" disabled [(ngModel)]="businessHours[1]"/>
          </div>
        </div>
        <!--<div class="row" *ngFor="let d of notWorkingDays; i as index">
          <div class="col-md-2 align-lft padd-top5p">
            <div class="form-group">
              <input type="checkbox" disabled />
              <span class="padd-lft2p"> {{getDayName(d)}}</span>
            </div>
          </div>
          <div class="col-md-3">
            <span>Not working on this day</span>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
